const AUTH_TOKEN_KEY = "authToken";

// Decodes the token payload. Accepts a JWT (header.payload.signature) or a bare base64 JSON payload.
const decodeTokenPayload = (token) => {
  const parts = token.split(".");
  const payload = parts.length === 3 ? parts[1] : parts[0];
  const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
  const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
  return JSON.parse(atob(padded));
};

// True only when a token is stored, decodes, and has not expired
export const hasValidAuthToken = () => {
  let token = null;
  try {
    token = localStorage.getItem(AUTH_TOKEN_KEY);
  } catch (error) {
    return false;
  }
  if (!token) return false;

  try {
    const payload = decodeTokenPayload(token);
    if (payload.exp && payload.exp * 1000 <= Date.now()) {
      localStorage.removeItem(AUTH_TOKEN_KEY);
      return false;
    }
    return true;
  } catch (error) {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    return false;
  }
};

// The signed-in staff member, from the stored token (used to attribute notes)
export const getCurrentUser = () => {
  try {
    const payload = decodeTokenPayload(localStorage.getItem(AUTH_TOKEN_KEY) || "");
    return {
      id: payload.userId || "",
      name: payload.staffFullName || payload.userId || "Unknown user",
      picture: payload.profilePicture || "",
    };
  } catch (error) {
    return { id: "", name: "Unknown user", picture: "" };
  }
};
